import {
    Box,
    Button,
    Typography,
    TextField,
    Grid,
    MenuItem
} from '@mui/material'
import React, { ChangeEvent, FormEvent, useState } from 'react'
import { message } from 'antd'
import axios from 'axios'
import { FindAgreementNoUrl } from '../../common/url'
import { isDesktop } from 'react-device-detect'
import { useTranslation } from 'react-i18next'

export const SMFindAgreementNumber: React.FC = () => {

    const { t } = useTranslation()

    // ======================= HOOKS
    const [step, setStep] = useState(1)

    const [forms, setForms] = useState({
        nric: '',
        mobileNumber: '',
        vehiclePlateNumber: ''
    })

    const [financingType, setFinancingType] = useState(0)

    const financingTypeList = [t('t442'), t('t443')]

    const [list1, setList1] = useState<any[]>([])

    const financingTypeSelectItem = () => (
        financingTypeList.map((item, index) => (
            financingTypeMenuItem(index)
        ))
    )

    const financingTypeMenuItem = (index: number) => {
        return (
            <MenuItem key={index} value={financingTypeList[index]} onClick={() => updateSelectFinancingType(index)}>
                {financingTypeList[index]}
            </MenuItem>
        )
    }

    const updateSelectFinancingType = (index: number) => {
        setFinancingType(index)
    }

    const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
        const { id, value } = e.target

        setForms((prevForms) => ({
            ...prevForms,
            [id]: value,
        }))
    }

    const handleSubmit = async (e: FormEvent) => {
        e.preventDefault()

        if (forms.nric === null || forms.nric === '') {
            message.destroy()
            message.open({
                type: 'error',
                content: 'Your NRIC No. Cannot Be Blank.',
                style: { marginTop: '40vh' },
            })
            return
        }

        if (forms.vehiclePlateNumber === null || forms.vehiclePlateNumber === '') {
            message.destroy()
            message.open({
                type: 'error',
                content: financingType === 0 ? 'Your Mobile Number Cannot Be Blank.' : 'Motorcycle Plate Number Cannot Be Blank.',
                style: { marginTop: '40vh' },
            })
            return
        }

        var params = {}
        if (financingType === 0) {
            params = {
                'type': 'pf',
                'nric': forms.nric,
                'mobile': forms.mobileNumber,
            }
        } else {
            params = {
                'type': 'motorcycle',
                'nric': forms.nric,
                'plateNo': forms.vehiclePlateNumber
            }
        }

        message.destroy()
        message.open({
            type: 'loading',
            content: 'loading...',
            duration: 0,
            style: { marginTop: '40vh' },
        })

        try {
            const response = await axios.post(FindAgreementNoUrl, params)
            const code = response.data['code']
            console.log('接口返回:', response.data)
            message.destroy()

            if (code === 200) {
                setForms({
                    nric: '',
                    vehiclePlateNumber: '',
                    mobileNumber: '',
                })

                // 直接使用接口返回的 data 数组
                const apiData = response.data.data
                if (apiData && apiData.length > 0) {
                    setStep(2)
                    // 直接赋值接口数据
                    setList1(apiData)
                } else {
                    setStep(3)
                }
            } else {
                setStep(4)
            }
        } catch (error) {
            message.destroy()
            setStep(4)
        }
    }

    const item1 = () => {
        return (
            <Box>
                <Typography fontSize={32} fontWeight={700} color={'#141F39'} paddingBottom={'40px'} textAlign={'center'}>
                    {t('t3014')}
                </Typography>

                <form onSubmit={handleSubmit}>
                    <Box sx={{
                        width: '100%',
                        backgroundColor: '#FFFFFF',
                        borderRadius: '10px',
                        alignItems: 'center',
                        boxShadow: '0px 10px 80px 3px #0000001A',
                        paddingLeft: isDesktop ? '50px' : '25px',
                        paddingRight: isDesktop ? '50px' : '25px',
                        paddingTop: '50px',
                        paddingBottom: '50px',
                        justifyContent: 'center',
                        display: 'flex',
                        flexDirection: 'column',
                    }}>
                        <Box sx={{ width: '100%' }}>
                            <Typography fontSize={16} fontWeight={500} color={'#141F39'} paddingBottom={'12px'}>
                                {t('t441')} <span style={{ color: '#FF4D49', fontSize: '16', fontWeight: '500' }}>*</span>
                            </Typography>
                            <TextField
                                select
                                fullWidth
                                variant='outlined'
                                value={financingTypeList[financingType]}
                                InputProps={{ style: { height: '53px' } }}
                            >
                                {financingTypeSelectItem()}
                            </TextField>
                        </Box>

                        <Box sx={{ width: '100%', paddingTop: '20px' }}>
                            <Typography fontSize={16} fontWeight={500} color={'#141F39'} paddingBottom={'12px'}>
                                Your NRIC No.<span style={{ color: '#FF4D49', fontSize: '16', fontWeight: '500' }}>*</span>
                                <span style={{ color: '#E4E4E4', fontSize: '12', fontWeight: '400' }}>(example:82123456789)</span>
                            </Typography>
                            <TextField
                                fullWidth
                                placeholder=''
                                variant='outlined'
                                id='nric'
                                InputProps={{ style: { height: '53px' } }}
                                onChange={handleInputChange}
                            />
                        </Box>

                        <Box sx={{ paddingTop: '20px', width: '100%' }}>
                            <Typography fontSize={16} fontWeight={500} color={'#141F39'} paddingBottom={'12px'}>
                                {financingType === 0 ? 'Your Mobile Number' : 'Motorcycle Plate Number'}
                                <span style={{ color: '#FF4D49', fontSize: '16', fontWeight: '500' }}>*</span>
                                <span style={{ color: '#E4E4E4', fontSize: '12', fontWeight: '400' }}>{financingType === 0 ? '(example:60123456789)' : '(example:ABC 1234)'}</span>
                            </Typography>
                            <TextField
                                fullWidth
                                placeholder=''
                                variant='outlined'
                                id='vehiclePlateNumber'
                                InputProps={{ style: { height: '53px' } }}
                                onChange={handleInputChange}
                            />
                        </Box>

                        <Box sx={{ paddingTop: '40px' }}>
                            <Button
                                type='submit'
                                sx={{
                                    borderRadius: '30px',
                                    height: '60px',
                                    width: '200px',
                                    bgcolor: '#FFC107',
                                    border: '1px solid #FFC107',
                                    color: '#141F39',
                                    '&:hover': { bgcolor: '#FFC107' },
                                    textTransform: 'none'
                                }}
                            >
                                {t('t446')}
                            </Button>
                        </Box>
                    </Box>
                </form>
            </Box>
        )
    }

    const item2 = () => {
        return (
            <Box>
                <Typography fontSize={32} fontWeight={700} color={'#141F39'} textAlign={'center'} paddingBottom={'40px'}>
                    {t('t3015')}
                </Typography>

                <Grid container rowSpacing={1} columnSpacing={0}>
                    {list1.map((item, index) => {
                        return (
                            <DetailCard
                                key={index}
                                name={item.name}
                                agreementNumber={item.agreementNo}
                                brand={item.brand}
                                model={item.model}
                                vehicleNumber={item.vehicleNo}
                                bankAccount={item.amBankAccount}
                            />
                        )
                    })}
                </Grid>
                <Box sx={{ textAlign: 'center', width: '100%' }}>
                    <Button
                        onClick={() => window.close()}
                        sx={{
                            borderRadius: '20px',
                            height: '40px',
                            width: '160px',
                            bgcolor: '#FFC107',
                            border: '1px solid #FFC107',
                            color: '#141F39',
                            textTransform: 'none',
                            marginTop: '20px',
                            '&:hover': { bgcolor: '#FFC107' },
                        }}
                    >
                        Close
                    </Button>
                </Box>
            </Box>
        )
    }

    // 卡片组件
    const DetailCard = ({
        name,
        agreementNumber,
        brand,
        model,
        vehicleNumber,
        bankAccount,
    }) => {
        return (
            <Box
                sx={{
                    width: '100%',
                    backgroundColor: '#FFFFFF',
                    borderRadius: '12px',
                    padding: isDesktop ? '40px 50px' : '20px 20px',
                    marginBottom: '30px',
                }}
            >
                <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '6px 0', marginBottom: '12px' }}>
                    <Typography fontSize={16} fontWeight={500} color="#999999">Name</Typography>
                    <Typography fontSize={16} fontWeight={500} color="#141F39">{name}</Typography>

                    <Typography fontSize={16} fontWeight={500} color="#999999">Agreement Number</Typography>
                    <Typography fontSize={16} fontWeight={500} color="#141F39">{agreementNumber}</Typography>

                    {brand && brand.trim() !== '' && (
                        <>
                            <Typography fontSize={16} fontWeight={500} color="#999999">Brand</Typography>
                            <Typography fontSize={16} fontWeight={500} color="#141F39">{brand}</Typography>
                        </>
                    )}

                    {model && model.trim() !== '' && (
                        <>
                            <Typography fontSize={16} fontWeight={500} color="#999999">Model</Typography>
                            <Typography fontSize={16} fontWeight={500} color="#141F39">{model}</Typography>
                        </>
                    )}

                    {vehicleNumber && vehicleNumber.trim() !== '' && (
                        <>
                            <Typography fontSize={16} fontWeight={500} color="#999999">Vehicle Number</Typography>
                            <Typography fontSize={16} fontWeight={500} color="#141F39">{vehicleNumber}</Typography>
                        </>
                    )}
                </Box>

                <Box sx={{ width: '100%', height: '1px', backgroundColor: '#E0E0E0', marginBottom: '30px' }} />

                <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px 0' }}>
                    <Typography fontSize={16} fontWeight={500} color="#999999">Your AmBank Collection Account</Typography>
                    <Typography fontSize={16} fontWeight={500} color="#141F39">{bankAccount}</Typography>
                </Box>
            </Box>
        )
    }

    const item3 = () => {
        return (
            <Box>
                <Typography fontSize={32} fontWeight={700} color={'#141F39'} textAlign={'center'}>
                    {t('t3015')}
                </Typography>
                <Box sx={{
                    marginTop: '40px',
                    padding: '50px 25px',
                    backgroundColor: '#FFFFFF',
                    borderRadius: '10px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}>
                    <Typography fontSize={20} fontWeight={600} color={'#141F39'}>No record found</Typography>
                    <Typography fontSize={16} fontWeight={500} color={'#141F39'} paddingTop={'15px'} textAlign="center">
                        Please contact us at wecare@shenmacredit.com.my, or WhatsApp at 011-3301 1633
                    </Typography>
                    <Button
                        onClick={() => setStep(1)}
                        sx={{
                            borderRadius: '20px',
                            height: '40px',
                            width: '160px',
                            bgcolor: '#FFC107',
                            border: '1px solid #FFC107',
                            color: '#141F39',
                            textTransform: 'none',
                            marginTop: '50px',
                            '&:hover': { bgcolor: '#FFC107' },
                        }}
                    >
                        Back
                    </Button>
                </Box>
            </Box>
        )
    }

    const item4 = () => {
        return (
            <Box>
                <Typography fontSize={32} fontWeight={700} color={'#141F39'} textAlign={'center'}>
                    {t('t3015')}
                </Typography>
                <Box sx={{
                    marginTop: '40px',
                    padding: '50px 25px',
                    backgroundColor: '#FFFFFF',
                    borderRadius: '10px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}>
                    <Typography fontSize={20} fontWeight={600} color={'#141F39'}>Error</Typography>
                    <Typography fontSize={16} fontWeight={500} color={'#141F39'} paddingTop={'15px'}>
                        Please try again.
                    </Typography>
                    <Button
                        onClick={() => setStep(1)}
                        sx={{
                            borderRadius: '20px',
                            height: '40px',
                            width: '160px',
                            bgcolor: '#FFC107',
                            border: '1px solid #FFC107',
                            color: '#141F39',
                            textTransform: 'none',
                            marginTop: '50px',
                            '&:hover': { bgcolor: '#FFC107' },
                        }}
                    >
                        Back
                    </Button>
                </Box>
            </Box>
        )
    }

    // ======================= VIEWS
    return (
        <Box sx={{
            width: '100%',
            backgroundColor: '#FFF8E7',
            padding: '60px 0',
            paddingLeft: isDesktop ? '240px' : '12px',
            paddingRight: isDesktop ? '240px' : '12px',
        }}>
            {step === 1 ? item1()
                : step === 2 ? item2()
                    : step === 3 ? item3()
                        : item4()}
        </Box>
    )
}

export default SMFindAgreementNumber